import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { useMilitaryVerificationError } from '../../../contexts/MilitaryVerificationErrorContext';

export const MilitaryVerificationErrorBanner = () => {
  const { error, clearError } = useMilitaryVerificationError();

  if (!error) {
    return null;
  }

  return (
    <div className="sui-mb-4 sui-max-w-max">
      <Alert
        status={error.status || 'error'}
        headline={error.headline}
        onClose={clearError}
        size="large"
      >
        {error.message}
      </Alert>
    </div>
  );
};

MilitaryVerificationErrorBanner.displayName = 'MilitaryVerificationErrorBanner';
